import React, { useRef, useEffect } from 'react';
import { Container } from 'reactstrap';
import { getAssetUrl } from '../../services/cdn';

const FloatingCTA = () => {


  return (
    <div className="floating_btn">
        <a href="https://koopsiklo.sidc.coop/store">Apply for a Loan</a>
    </div>
  );
};

export default FloatingCTA;
